import EventLink from "../EventLink";
import MotionDiv from "../MotionDiv";
import React, { useContext, useRef, useState } from "react";
import { AnimatePresence } from "framer-motion";
import { Trans } from "react-i18next";
import {
  Flex,
  Text,
  Button,
  VStack,
  Box,
  useBreakpointValue,
} from "@chakra-ui/react";
import { ChevronLeftIcon, CloseIcon } from "@chakra-ui/icons";
import { useHistory } from "react-router-dom";
import { DotPaging, useContainerBreakpoint } from "@radianse/components";
import { _basePath } from "../../config/index";
import { UserContext } from "../../context";

const sortFn = (a, b) => {
  const nameA = a.name.toUpperCase(); // ignore upper and lowercase
  const nameB = b.name.toUpperCase(); // ignore upper and lowercase
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  return 0;
};

const EventLayout = ({ events }) => {
  const { setUserData } = useContext(UserContext);
  const history = useHistory();
  const gridRef = useRef(null);
  const containerBreakpoints = useContainerBreakpoint(gridRef, {
    x: null,
    y: {
      1: 1,
      220: 2,
      340: 3,
      600: 3,
      750: 3,
    },
  });
  const columns = useBreakpointValue({
    base: 2,
    sm: 3,
    lg: 4,
    xl: 5,
    "2xl": 6,
  });
  const [[page, direction], setPage] = useState([1, 0]);
  const recordsPerPage = containerBreakpoints?.y
    ? columns * containerBreakpoints.y
    : columns;
  const indexOfLastRecord = page * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = events.children.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );
  const nPages = Math.ceil(events.children.length / recordsPerPage);
  const canPrevPage = page > 1;
  const canNextPage = page < nPages;
  const paginate = (newDirection) => {
    setPage([page + newDirection, newDirection]);
  };
  const swipeConfidenceThreshold = 10000;
  const swipePower = (offset, velocity) => {
    return Math.abs(offset) * velocity;
  };
  let subCategory = "Events";
  if (events.children && events.children.length > 0) {
    subCategory = "ElementTree";
  }
  // useEffect(() => {
  //   debugger;
  // }, [currentRecords]);
  const onCancel = () => {
    setUserData({ user: null, loggedIn: false });
    history.push(_basePath);
  };

  if (!currentRecords) {
    return null;
  }
  return (
    <VStack
      color={"#fff"}
      direction={"column"}
      alignItems={"start"}
      flex={1}
      h={"full"}
      spacing={5}
    >
      <Text
        as={"h2"}
        color="brand.secondary.500"
        fontSize="2xl"
        textAlign={"left"}
        fontWeight={"bold"}
      >
        <Trans i18nKey={"new_appointment"}>New Appointment:</Trans>{" "}
        {!!events?.name && (
          <Trans i18nKey={`${subCategory}.${events?.name}`} ns={subCategory}>
            {events?.name}
          </Trans>
        )}
      </Text>
      <Text as="p" textAlign={"left"}>
        <Trans i18nKey={"select_an_event"}>
          Select an event option below to reserve your appointment.
        </Trans>
      </Text>
      <Flex
        m={30}
        flex={1}
        w={"full"}
        direction={"column"}
        px={[10, 15, 20, 25, 30]}
        overflow={"hidden"}
        position={"relative"}
        ref={gridRef}
      >
        <AnimatePresence initial={false} custom={direction}>
          <MotionDiv
            layerStyle={"kioskGridWrapper"}
            key={page}
            drag={"x"}
            dragConstraints={{ left: 0, right: 0 }}
            dragElastic={0.5}
            onDragEnd={(e, { offset, velocity }) => {
              const swipe = swipePower(offset.x, velocity.x);

              if (swipe < -swipeConfidenceThreshold) {
                canNextPage && paginate(1);
              } else if (swipe > swipeConfidenceThreshold) {
                canPrevPage && paginate(-1);
              }
            }}
          >
            <Box layerStyle={"kioskGrid"}>
              {currentRecords.sort(sortFn).map((child, i) => (
                <EventLink event={child} key={child.id} index={i} />
              ))}
            </Box>
          </MotionDiv>
        </AnimatePresence>
      </Flex>

      <Box display={"grid"} gridTemplateColumns={"auto 1fr auto"} w={"full"}>
        <Button
          justifySelf={"start"}
          variant={"kioskGhost"}
          aria-label={"Back"}
          onClick={history.goBack}
          leftIcon={<ChevronLeftIcon boxSize={10} />}
          data-testid={"back-button"}
        >
          <Trans i18nKey={"actions.back"}>Back</Trans>
        </Button>
        <DotPaging nPages={nPages} currentPage={page} paginate={paginate} />
        <Button
          justifySelf={"end"}
          variant={"kioskGhost"}
          aria-label={"Cancel"}
          onClick={onCancel}
          data-testid={"cancel-button"}
          leftIcon={<CloseIcon boxSize={5} />}
        >
          <Trans i18nKey={"actions.cancel"}>Cancel</Trans>
        </Button>
      </Box>
    </VStack>
  );
};

export default EventLayout;
